nc_initScrollClass('.header', '.header', 'fixed');